import React from "react";
import { Box, Paper, Typography, Divider } from "@mui/material";

const SectionPaper = ({ title, children, action, flex = false }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.5, md: 2 },
      mb: flex ? 0 : 2,
      border: "1px solid var(--border-color)",
      borderRadius: 2,
      backgroundColor: "var(--bg-paper)",
      display: flex ? "flex" : "block",
      flexDirection: flex ? "column" : undefined,
      flex: flex ? 1 : undefined,
      minHeight: flex ? 0 : undefined,
      overflow: flex ? "hidden" : undefined,
    }}
  >
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 1.5, flexShrink: 0 }}
    >
      <Typography
        fontFamily="Poppins"
        fontWeight={600}
        fontSize="15px"
        color="var(--text-primary)"
      >
        {title}
      </Typography>
      {action}
    </Box>
    <Divider
      sx={{ mb: 1.5, borderColor: "var(--border-color)", flexShrink: 0 }}
    />
    <Box
      sx={{
        flex: flex ? 1 : undefined,
        overflow: flex ? "hidden" : undefined,
        display: flex ? "flex" : "block",
        flexDirection: flex ? "column" : undefined,
      }}
    >
      {children}
    </Box>
  </Paper>
);

export default SectionPaper;
